import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"
import apiPath from "../../shared/apiPath"
// -- import * as _ from "lodash-es"

const content_type = "system_setting"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}
const fields = [
  {
    key: "id",
    label: "编号"
  },
  {
    key: "code",
    label: "编码"
  },
  {
    key: "setting_value",
    label: "设置内容"
  }
]

const dataForm = {}

const methods = {
  async GetData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async SaveData(data) {
    let _params = {}
    _params.id = data.id
    _params.code = data.code
    _params.setting_value = data.setting_value
    let result = null
    if (data.id == "") {
      delete _params.id
      result = await biz_data
        .insertAction({
          params: _params,
          fields: _.map(fields, "key")
        })
        .run()
    } else {
      result = await biz_data
        .updateAction({
          params: _params,
          fields: _.map(fields, "key")
        })
        .run()
    }
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async GetAsyncTable() {
    let biz_data = new biz_data_helper.base_entity_helper(
      "getAsyncTable",
      {},
      {}
    )

    let result = await biz_data
      .execAction({
        params: {},
        fields: []
      }).run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data[0]
    } else {
      return null
    }
  },
  async SyncData(p) {
    let _actions = []
    let biz_data = new biz_data_helper.base_entity_helper(
      "sync_tables",
      {},
      {}
    )
    _actions.push(
      biz_data
        .execAction({
          params: p,
          fields: []
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0] &&
      result.data.BatchResult.Actions[0].Result &&
      result.data.BatchResult.Actions[0].Result.Data
    ) {
      return true
    } else {
      return null
    }
  },
  async GetDataLanguage(_params, fields) {
    let lang_biz_data = new biz_data_helper.base_entity_helper(
      "Language",
      create,
      descriptor
    )
    let result = await lang_biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async LanguageSaveData(data, fields, action_state) {
    let lang_biz_data = new biz_data_helper.base_entity_helper(
      "Language",
      create,
      descriptor
    )
    let result = null
    if (action_state == "add") {
      delete data[0].id
      result = await lang_biz_data
        .insertAction({
          params: data,
          fields: _.map(fields, "key")
        })
        .run()
    } else {
      result = await lang_biz_data
        .updateAction({
          params: data,
          fields: _.map(fields, "key")
        })
        .run()
    }
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async LanguageRemoveData(items) {
    let lang_biz_data = new biz_data_helper.base_entity_helper(
      "Language",
      create,
      descriptor
    )
    let result = null
    result = await lang_biz_data
      .removeAction({
        params: items
      }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
// export * from "../../shared/biz_data_helper"
export { fields, dataForm, biz_data, methods }
